import { useState, createContext, useEffect } from 'react';
import './App.css';
import { HelmetProvider } from 'react-helmet-async';
import { useLocation, Routes, Route, BrowserRouter as Router } from "react-router-dom";
import { Header, Footer, Homepage, Comingsoon, Contactus } from './Components/Functionality/'
import SpectralLibraryHomePage from './spectralLibrary/spectralLibraryHomePage/spectralLibraryHomePage';
import { UploaderHomePage } from './spectralLibrary/Uploader/uploaderHomePage';
import { Chemometrics } from './spectralLibrary/Chemometrics/Chemometrics';
import { userAuth } from './firebase/firebase';
import { onAuthStateChanged } from '@firebase/auth';
import SignIn from './Components/Functionality/signIn/SignIn';
import Register from './Components/Functionality/signIn/Register';
import GA4React from 'ga-4-react';
import ForgotPassword from './Components/Functionality/signIn/Forgotpassword';
import PricingPage from './Components/Functionality/pricing/pricing';
import ResponsivePricingPage from './Components/Functionality/pricing/pricing';
import AboutTeamPage from './Components/Functionality/about/about';
import News from './Components/Functionality/about/News/News';
// Import ArticlePage component for displaying individual articles
import ArticlePage from './Components/Functionality/articles/articlePage';
// Import the ChatSupportWidget component
import ChatSupportWidget from './Components/Functionality/supportwidget/SupportWidget';
import MaintenanceCountdown from './Components/Functionality/undermaintence/MaintenanceCountdown';
import NotFound from './Pages/NotFound/NotFound';
// Import ToastContainer and CSS for react-toastify
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const LoginContext = createContext();
export const UserEmail = createContext();

const ga4react = new GA4React("G-9CC5N8N5QZ", {debug_mode: true});

// Improved ScrollToTop component that works with React Router v6
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null; // This component doesn't render anything
}

// HeaderWrapper component - handles conditional rendering based on path
const HeaderWrapper = () => {
  const location = useLocation();
  const noHeaderPaths = ['/login', '/sign-in', '/register', '/register-here', '/forgot-password'];
  
  // Check if current location path is in the list of paths that shouldn't show the header
  const shouldShowHeader = !noHeaderPaths.includes(location.pathname);
  
  return shouldShowHeader ? <Header /> : null;
};

function App() {
  const [isUserSignedIn, setIsUserSignedIn] = useState(true);
  const [email, setEmail] = useState("");
  
  useEffect(() => {
    ga4react.initialize().then(
      (ga4) => {
        ga4.pageview("path");
        ga4.gtag("pageview", "path"); // or your custom gtag event
      },
      (err) => {
        // Silent error handling
      }
    );
  }, []);
  
  onAuthStateChanged(userAuth, (user) => {
    if (user) {
      setEmail(user.email);
      UserEmail.Provider = user.email;
      return setIsUserSignedIn(true);      
    }
    setIsUserSignedIn(false);
  });
  
  if (isUserSignedIn === true) {
    return (
      <HelmetProvider>
        <Router>
          <LoginContext.Provider value={isUserSignedIn}>
            <ScrollToTop /> {/* Add ScrollToTop inside Router but outside Routes */}
            <HeaderWrapper /> {/* Use HeaderWrapper instead of directly using Header */}
            <Routes>
              <Route path="/" element={<Homepage/>}/>
              <Route path="/contact-us" element={<Contactus/>}/>
              <Route path="/spectral-library" element={<SpectralLibraryHomePage tab="explore" />}/>
              <Route path="/spectral-library/database" element={<SpectralLibraryHomePage tab="explore" />}/>
              <Route path="/spectral-library/analyse" element={<SpectralLibraryHomePage tab="analysis" />}/>
              <Route path="/spectral-library/upload" element={<SpectralLibraryHomePage tab="upload" />}/>
              <Route path="/upload" element={<UploaderHomePage/>}/>
              {/* News routes */}
              <Route path="/news" element={<News/>}/>
              <Route path="/news/:articleSlug" element={<ArticlePage />}/>
              {/* Other routes */}
              <Route path="/pricing" element={<ResponsivePricingPage/>}/>
              <Route path="/about" element={<AboutTeamPage/>}/>
              <Route path="/sign-in" element={<MaintenanceCountdown/>}/>
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer/>
            {/* Add the ChatSupportWidget component here */}
            <ChatSupportWidget />
            
            {/* Add ToastContainer for notifications */}
            <ToastContainer
              position="top-center"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </LoginContext.Provider>
        </Router>
      </HelmetProvider>
    );
  } else {
    return (
      <HelmetProvider>
        <Router>
          <LoginContext.Provider value={isUserSignedIn}>
            <ScrollToTop /> {/* Add ScrollToTop inside Router but outside Routes */}
            <HeaderWrapper /> {/* Use HeaderWrapper instead of directly using Header */}
            <Routes>
              <Route path="/" element={<Homepage/>}/>
              <Route path="/sign-in" element={<MaintenanceCountdown/>}/>
              <Route path="/forgot-password" element={<MaintenanceCountdown />}/>
              <Route path="/contact-us" element={<Contactus/>}/>
              {/* News routes */}
              <Route path="/news" element={<News/>}/>
              <Route path="/news/:articleSlug" element={<ArticlePage />}/>
              {/* Other routes */}
              <Route path="/spectral-library" element={<SpectralLibraryHomePage tab="explore" />}/>
              <Route path="/spectral-library/database" element={<SpectralLibraryHomePage tab="explore" />}/>
              <Route path="/spectral-library/analyse" element={<SpectralLibraryHomePage tab="analysis" />}/>
              <Route path="/spectral-library/upload" element={<SpectralLibraryHomePage tab="upload" />}/>
              <Route path="/pricing" element={<ResponsivePricingPage/>}/>
              <Route path="/upload" element={<MaintenanceCountdown/>}/>
              <Route path="/register" element={<MaintenanceCountdown />}/>
              <Route path="/about" element={<AboutTeamPage/>}/>
              <Route path="*" element={<NotFound />} /> 
            </Routes>
            <Footer/>
            {/* Add the ChatSupportWidget component here as well */}
            <ChatSupportWidget />
            
            {/* Add ToastContainer for notifications */}
            <ToastContainer
              position="top-center"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </LoginContext.Provider>
        </Router>
      </HelmetProvider>
    );
  }
}

export default App;